<ion-card
  (click)="
    !isLoading() && userTimeSheetFileAccessInput() && presentActionSheet()
  "
  class="metrics-card"
>
  @if (!isLoading()) {
    <ion-card-content class="metrics-card-content">
      @if (userTimeSheetFileAccessInput()) {
        <ion-item
          lines="none"
          class="timesheet-item"
          lines="none"
          detail="true"
        >
          <fa-icon [icon]="faFilePdf" class="pdf-icon"></fa-icon>
          <span class="file_name">{{ fileName() }}</span>
        </ion-item>
      } @else {
        <ion-item lines="none" class="locked-item">
          <fa-icon [icon]="faFileLock" class="me-1 file-lock-icon"></fa-icon>
        </ion-item>
      }
    </ion-card-content>
  } @else {
    <ion-item lines="none" class="loading-item">
      <ion-skeleton-text
        [animated]="true"
        class="subtitle-skeleton"
      ></ion-skeleton-text>
    </ion-item>
  }
</ion-card>
